// components/sections/PregnancyConsumptionSection.tsx
import React from "react";
import { AlertTriangle, FileText } from "lucide-react";
import { TextAreaField } from "../form/FormComponents_PediatricsRegistration";
import type { FormData } from "../../types/consultation";

interface PregnancyConsumptionSectionProps {
  formData: FormData;
  updatePediatricsInfo: (field: string, value: string | boolean) => void;
}

export const PregnancyConsumptionSection: React.FC<PregnancyConsumptionSectionProps> = ({
  formData,
  updatePediatricsInfo,
}) => {
  return (
    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-6 rounded-2xl shadow-lg border border-yellow-100 mb-8">
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <AlertTriangle className="mr-2 text-yellow-600" size={24} />
        Consommation pendant la grossesse
      </h3>
      <div className="space-y-4">
        <div>
          <label className="flex items-center text-sm font-semibold text-gray-700">
            Consommait-elle du tabac ou des médicaments pendant la grossesse&nbsp;?
          </label>
          <div className="flex items-center gap-6 mt-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="tabacMedicamentsGrossesse"
                checked={
                  formData.pediatrieInfo?.tabacMedicamentsGrossesse === true
                }
                onChange={() =>
                  updatePediatricsInfo("tabacMedicamentsGrossesse", true)
                }
                className="accent-yellow-600"
              />
              <span className="text-sm">Oui</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="tabacMedicamentsGrossesse"
                checked={
                  formData.pediatrieInfo?.tabacMedicamentsGrossesse === false
                }
                onChange={() =>
                  updatePediatricsInfo("tabacMedicamentsGrossesse", false)
                }
                className="accent-yellow-600"
              />
              <span className="text-sm">Non</span>
            </label>
          </div>
        </div>
        {formData.pediatrieInfo?.tabacMedicamentsGrossesse === true && (
          <TextAreaField
            label="Description (type, fréquence, etc.)"
            value={
              formData.pediatrieInfo?.descriptionTabacMedicamentsGrossesse || ""
            }
            onChange={(value) =>
              updatePediatricsInfo(
                "descriptionTabacMedicamentsGrossesse",
                value
              )
            }
            placeholder="Précisez le type de substance, la fréquence, etc."
            icon={FileText}
            rows={3}
          />
        )}
      </div>
    </div>
  );
};